import { OrganizationMetadataGroup } from '../@types';
import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetAllSalesforceOrganizationsByCustomerRequest = {
	customerId?: number;
	shardName?: string;
};

export type GetAllSalesforceOrganizationsByCustomerResponse = OrganizationMetadataGroup;

export const getAllSalesforceOrganizationsByCustomer = createGetEndpoint<
	GetAllSalesforceOrganizationsByCustomerRequest,
	GetAllSalesforceOrganizationsByCustomerResponse
>((request) => `/api/v3/core/organizations/salesforce/all/${request?.customerId}`, {
	headers: (request) => {
		if (request?.shardName) {
			return { [ HttpHeader.Shard ]: request.shardName };
		}

		return {};
	}
});
